module.exports = { prefix: 'fas', iconName: 'angle-down', icon: [320, 512, [], "f107", "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"] };


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/seiu503-wordpress/wp-content/themes/seiu503-wp/node_modules/@fortawesome/fontawesome-free-solid/faAngleDown.js
// module id = 16
// module chunks = 0